<template>
    <v-card-text v-if="orderData" class="pa-4">
        <div class="pb-2">
            <h3
                class="overline my-2 ml-1 font-weight-bold"
                style="font-size: 0.9rem !important"
            >
                <span class="font-weight-regular">Pedido</span>
                {{ orderData.id }}
            </h3>
            <div class="d-flex align-center mt-n3">
                <v-btn
                    depressed
                    small
                    :color="
                        stateUser[
                            getActualOrderFromHistorico
                                ? getActualOrderFromHistorico.superStatus
                                : orderNumberToState[orderData.state]
                        ]['color']
                    "
                >
                    <div v-if="getActualOrderFromHistorico">
                        {{
                            `(${getActualOrderFromHistorico.status.code}) ${getActualOrderFromHistorico.status.description}`
                        }}
                    </div>
                    <div v-else>
                        {{
                            `(${orderData.state}) ${
                                stateUser[orderNumberToState[orderData.state]]
                                    .nombre
                            }`
                        }}
                    </div>
                </v-btn>
                <v-btn
                    v-if="
                        getActualOrderFromHistorico &&
                        getActualOrderFromHistorico.statusOt
                    "
                    class="ml-2"
                    small
                    outlined
                    color="warning"
                >
                    {{ getActualOrderFromHistorico.statusOt }}
                </v-btn>
            </div>
        </div>
        <v-card elevation="0" class="mb-3">
            <v-card-title primary-title style="background-color: #e7e7e7">
                Documentos
            </v-card-title>
            <!-- <!-- <v-divider class="test"></v-divider> --> -->
            <v-card-text>
                <v-data-table
                    :headers="headersDocument"
                    :items="processItemsOrderDocument"
                    hide-default-footer
                    :loading="isLoadingContract"
                >
                    <template v-slot:item.downloadContract="{ item }">
                        <v-icon
                            :disabled="isLoadingContract"
                            color="primary"
                            @click="fetchContract(item.id)"
                        >
                            mdi-download
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-card elevation="0" class="mb-3">
            <v-card-title primary-title style="background-color: #e7e7e7">
                Datos de la venta
            </v-card-title>
            <!-- <!-- <v-divider class="test"></v-divider> --> -->
            <v-card-text class="py-4">
                <v-row class="font-weight-medium">
                    <v-col cols="12" md="3" align="start"
                        >Fecha de pedido:
                        <span class="font-weight-light">{{
                            formatDateLarge(orderData.orderDate)
                        }}</span>
                    </v-col>
                    <v-col cols="12" md="3" align="center"
                        >Canal de venta:
                        <span class="text-capitalize font-weight-light">{{
                            orderData.characteristics
                                .find(({ name }) => name == 'channel')
                                .value.replaceAll('_', ' ')
                        }}</span>
                    </v-col>
                    <v-col cols="12" md="4" align="center"
                        >Cuenta bancaria:
                        <span class="text-capitalize font-weight-light">{{
                            orderData.paymentMean
                                ? orderData.paymentMean[0].bankAccount.iban
                                : ''
                        }}</span>
                    </v-col>
                    <v-col cols="12" md="2" align="center"
                        >SFID:
                        <span class="font-weight-normal">{{
                            orderData.sfid
                        }}</span></v-col
                    >
                </v-row>
            </v-card-text>
        </v-card>
        <v-card elevation="0">
            <v-expansion-panels accordion flat tile>
                <v-expansion-panel>
                    <v-expansion-panel-header style="background-color: #e7e7e7">
                        <v-card-title class="pa-0">
                            {{ orderData.customer.products[0].description }}
                        </v-card-title>
                    </v-expansion-panel-header>
                    <!-- <!-- <v-divider class="test"></v-divider> --> -->
                    <v-expansion-panel-content>
                        <v-card-text class="py-4">
                            <v-row class="font-weight-medium">
                                <v-col
                                    cols="12"
                                    md="12"
                                    align="start"
                                    class="overline"
                                >
                                    <p
                                        class="font-weight-bold blue--text mb-0"
                                        style="font-size: 0.9rem !important"
                                    >
                                        Resumen de precios
                                    </p>

                                    <p class="ml-2 mt-n1">
                                        Precio sin impuestos:
                                        <span
                                            class="black--text"
                                            style="font-size: 1rem !important"
                                            >{{
                                                parseInt(
                                                    orderData.customer
                                                        .products[0].monthly_fee
                                                )
                                            }}
                                            <span
                                                style="
                                                    font-size: 1rem !important;
                                                "
                                                >€<span class="subtitle-2"
                                                    >/mes</span
                                                ></span
                                            ></span
                                        >
                                    </p>
                                </v-col>
                            </v-row>
                            <div
                                v-if="
                                    orderData.customer.products[0].category !=
                                        'mobile_only' &&
                                    orderData.customer.products[0]
                                        .productsSpecifications.length > 1
                                "
                            >
                                <v-divider class="mb-2 test2"></v-divider>
                                <h4>Información de la linea:</h4>
                                <div
                                    cols="12"
                                    md="12"
                                    class="ml-4 mt-2"
                                >
                                    <div class="d-flex align-end">
                                        <v-icon class="mr-2"
                                            >mdi-phone-classic</v-icon
                                        >
                                        <span class="mr-2">
                                            {{
                                                orderData.customer.products[0]
                                                    .productsSpecifications[1]
                                                    .id
                                            }}
                                        </span>
                                        <span
                                            v-if="
                                                orderData.customer.products[0].productsSpecifications[1].productSpecCharacteristic.find(
                                                    ({ name }) =>
                                                        name ==
                                                        'donor_operator_name'
                                                )
                                            "
                                            class="font-weight-medium"
                                        >
                                            <span
                                                class="mr-1 font-weight-regular"
                                                >Operador donante:
                                            </span>
                                            {{
                                                orderData.customer.products[0].productsSpecifications[1].productSpecCharacteristic.find(
                                                    ({ name }) =>
                                                        name ==
                                                        'donor_operator_name'
                                                ).value
                                            }}
                                        </span>
                                    </div>
                                </div>
                                <h4 class="mt-3">Dirección de instalación:</h4>
                                <div
                                    cols="12"
                                    md="12"
                                    class="ml-4 mt-2"
                                >
                                    <div class="d-flex align-end">
                                        <v-icon class="mr-2">mdi-home</v-icon>
                                        <span class="mr-2">
                                            {{ getAddressInstallation }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="
                                    orderData.customer.products[0].category ==
                                        'mobile_only' ||
                                    orderData.customer.products[0].category ==
                                        'convergent'
                                "
                            >
                                <v-divider class="mt-4 test2"></v-divider>
                                <h4 class="mt-2">Información de la linea:</h4>
                                <div
                                    cols="12"
                                    md="12"
                                    class="ml-4 mt-2"
                                >
                                    <div class="d-flex align-end">
                                        <v-icon class="mr-2">mdi-phone</v-icon>
                                        <span class="mr-2">
                                            {{
                                                orderData.customer.products[0]
                                                    .productsSpecifications[0]
                                                    .id
                                            }}
                                        </span>
                                        <span
                                            v-if="
                                                orderData.customer.products[0].productsSpecifications[0].productSpecCharacteristic.find(
                                                    ({ name }) => name == 'icc'
                                                )
                                            "
                                            class="font-weight-medium"
                                        >
                                            <span
                                                class="mr-1 font-weight-regular"
                                                >ICC:
                                            </span>
                                            {{
                                                orderData.customer.products[0].productsSpecifications[0].productSpecCharacteristic.find(
                                                    ({ name }) => name == 'icc'
                                                ).value
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="isLoadingOrderDetail"
                                class="d-flex justify-center my-4"
                            >
                                <v-progress-circular
                                    indeterminate
                                ></v-progress-circular>
                            </div>
                            <div v-else>
                                <div
                                    v-if="
                                        orderDataDetail &&
                                        orderDataDetail.subscriptions.length &&
                                        orderDataDetail.subscriptions[0].hasOwnProperty(
                                            'handset'
                                        ) &&
                                        orderDataDetail.subscriptions[0].handset
                                            .length
                                    "
                                >
                                    <v-divider class="mt-4 test2"></v-divider>
                                    <h4 class="mt-2">
                                        Información dispositivo:
                                    </h4>
                                    <div
                                        cols="12"
                                        md="12"
                                        class="ml-4 mt-2"
                                        v-for="(
                                            handset, index
                                        ) in orderDataDetail.subscriptions[0]
                                            .handset"
                                        :key="index"
                                    >
                                        <div class="d-flex align-end">
                                            <div
                                                style="width: 20%"
                                                class="d-flex justify-start"
                                            >
                                                <v-icon class="mr-2"
                                                    >mdi-cellphone</v-icon
                                                >
                                                <span class="mr-2">
                                                    {{ handset.name }}
                                                </span>
                                            </div>
                                            <div
                                                style="width: 80%"
                                                class="d-flex justify-end"
                                            >
                                                <span
                                                    v-if="handset.imei"
                                                    class="bg-gray overline"
                                                >
                                                    IMEI:
                                                    <span
                                                        class="font-weight-bold"
                                                    >
                                                        {{ handset.imei }}
                                                    </span>
                                                </span>
                                                <span class="bg-gray overline">
                                                    Pago inicial:
                                                    <span
                                                        class="font-weight-bold"
                                                    >
                                                        {{
                                                            Number.parseFloat(
                                                                handset.initial_payment
                                                            ).toFixed(2)
                                                        }}
                                                        €
                                                    </span>
                                                </span>
                                                <span class="bg-gray overline">
                                                    Pago final:
                                                    <span
                                                        class="font-weight-bold"
                                                    >
                                                        {{
                                                            Number.parseFloat(
                                                                handset.final_payment
                                                            ).toFixed(2)
                                                        }}
                                                        €
                                                    </span>
                                                </span>
                                                <span
                                                    v-if="
                                                        handset.subsidy_contracts &&
                                                        handset
                                                            .subsidy_contracts
                                                            .length
                                                    "
                                                    class="bg-gray overline"
                                                >
                                                    Cuota:
                                                    <span
                                                        class="font-weight-bold"
                                                    >
                                                        {{
                                                            Number.parseFloat(
                                                                handset
                                                                    .subsidy_contracts[0]
                                                                    .monthly_fee
                                                            ).toFixed(2)
                                                        }}
                                                        €/mes ({{
                                                            handset
                                                                .subsidy_contracts[0]
                                                                .contract_length
                                                        }}
                                                        meses)
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-card-text>
</template>

<script>
import { mapState } from 'vuex';
import { formatDateLarge } from '@/util/libUtil.js';

export default {
    name: 'OrdersViewDetail',
    data: () => ({
        headersDocument: [
            {
                text: 'ID Contrato',
                value: 'id',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Titular',
                value: 'titular',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Suscripción',
                value: 'suscription',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Fecha de creación',
                value: 'datetimeCreation',
                align: 'center',
                sortable: false,
            },
            {
                text: '',
                value: 'downloadContract',
                align: 'center',
                sortable: false,
            },
        ],
    }),
    methods: {
        formatDateLarge,
        fetchContract(id) {
            this.$store.dispatch('orders/downloadPdfContract', id);
        },
    },
    computed: {
        getAddressInstallation() {
            let exist = this.orderData.customer.contactMedium.find(
                ({ type }) => type == 'InstallationAddressFixedLine'
            );
            if (exist) {
                const installation = exist.medium;
                const number = installation.characteristic.find(
                    ({ name }) => name == 'streetNumber'
                ).value;
                const province = installation.characteristic.find(
                    ({ name }) => name == 'province'
                ).value;

                return `${installation.streetOne} ${number} ${installation.streetTwo}. ${installation.postCode} ${installation.city} ${province}`;
            }
        },
        getActualOrderFromHistorico() {
            if (this.ordenes && this.orderData) {
                return this.ordenes.HISTORICO.find(
                    (item) => item.id === this.orderData.id
                );
            }
        },
        processItemsOrderDocument() {
            return [
                {
                    id: this.orderData.contractId,
                    titular: this.getNameTitularOrder,
                    suscription:
                        this.orderData.customer.products[0].productNumber,
                    datetimeCreation: formatDateLarge(this.orderData.orderDate),
                },
            ];
        },
        getNameTitularOrder() {
            return `${this.orderData.customer.firstName} ${this.orderData.customer.midName} ${this.orderData.customer.lastName}`;
        },
        ...mapState('teletrabajo', {
            ordenes: (state) => state.CompleteViewTtForm.details.form.ORDENES,
        }),
        ...mapState('orders', {
            orderData: (state) => state.order.orderData,
            stateUser: (state) => state.stateUser,
            isLoadingContract: (state) => state.contract.isLoadingContract,
            isLoadingOrderDetail: (state) => state.order.isLoadingOrderDetail,
            orderDataDetail: (state) => state.order.orderDataDetail,
            stateUser: (state) => state.stateUser,
            orderNumberToState: (state) => state.orderNumberToState,
        }),
    },
};
</script>

<style>
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
    padding: 0 !important;
}

.test2 {
    border-style: dotted;
    border-width: 1px !important;
    border-color: #e0e0e0 !important;
    height: 100%;
}

.bg-gray {
    border-style: dotted;
    border-width: 2px !important;
    border-color: #7e7e7e;
    background-color: #e0e0e0;
    margin-right: 5px;
    margin-left: 5px;
    padding: 3px;
}
</style>